// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2QJRw","file":"styles_file__2p-Ch"};